import { useState } from 'react';
import { bridge, useAsyncEffect } from '../../utils';
import { useIsForegroundNow } from '../useIsForegroundNow';

type UseLikeMapProps = {
  /** - api응답으로 생성한 likeMap */
  initialLikeMap?: Record<string, boolean>;
};

/**
 * - 찜상태관리
 * - 상품의 좋아요여부는 해당 객체를 활용해주세요
 * @returns { Record<string, boolean> } {'123': true, '456': false ...}
 */
export const useLikeMap = ({ initialLikeMap = {} }: UseLikeMapProps = {}) => {
  const [likeMap, setLikeMap] = useState(initialLikeMap);
  const isForeground = useIsForegroundNow();

  useAsyncEffect(async () => {
    if (isForeground) {
      const localGoodsLike = await bridge.getLocalGoodsLike();

      setLikeMap(prev => ({
        ...prev,
        ...localGoodsLike,
      }));
    }
  }, [isForeground]);

  // useAsyncEffect(async () => {
  //   const localGoodsLike = await bridge.getLocalGoodsLike();
  //   setLikeMap(prev => ({
  //     ...prev,
  //     ...localGoodsLike,
  //   }));
  // }, []);

  return { likeMap, setLikeMap };
};
